<div class="home-page__container">
	<h1 class="home-page__container--title">{{ 'title' | translate }}</h1>
	<p class="home-page__container--description">{{ 'firstSubtitle' | translate }}</p>
	<p class="home-page__container--description">{{ 'secondSubtitle' | translate }}</p>
	<p class="home-page__container--description">{{ 'navWarning' | translate }}</p>
	<a class="home-page__container__link" tabindex="0"  href="https://www.seg-social.es/wps/portal/wss/internet/HerramientasWeb/d5f5659b-7f86-4a30-8b3c-0dfd45f91e1f" target="_blank">Información sobre protección de datos</a>
</div>
